import { render, staticRenderFns } from "./PurchaseEdit.vue?vue&type=template&id=e2afc222&scoped=true"
import script from "./PurchaseEdit.vue?vue&type=script&lang=ts"
export * from "./PurchaseEdit.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseEdit.vue?vue&type=style&index=0&id=e2afc222&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2afc222",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2afc222')) {
      api.createRecord('e2afc222', component.options)
    } else {
      api.reload('e2afc222', component.options)
    }
    module.hot.accept("./PurchaseEdit.vue?vue&type=template&id=e2afc222&scoped=true", function () {
      api.rerender('e2afc222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchase/PurchaseEdit.vue"
export default component.exports